module.exports = __webpack_public_path__ + "img/spinning-not-allow.4f9ae028.svg";